module.exports = __webpack_public_path__ + "img/子计划数.495daa56.svg";